App.factory('CampaignLog', ['restmod', (restmod) => {
  return restmod.model()
}])
